<template>
  <div class="container">
    <nav class="navbar">
      <ul class="nav nav-tabs">
        <li>
          <img
            width="40"
            height="40"
            :src="require(`@/assets/diablo2/images/diablo2-logo.png`)"
          />
        </li>
        <li class="nav-item">
          <router-link
            class="nav-link"
            active-class="active"
            to="/diablo2/runeList"
            >룬 목록</router-link
          >
        </li>

        <li class="nav-item">
          <router-link
            class="nav-link"
            active-class="active"
            to="/diablo2/runewordSearch"
            >룬워드 검색</router-link
          >
        </li>
      </ul>
    </nav>

    <router-view />
  </div>
</template>

<script>
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.min.js";
// import { Tooltip } from "bootstrap/dist/js/bootstrap.esm.min.js";

export default {
  // mounted() {
  //   //inti tooltip
  //   Array.from(
  //     document.querySelectorAll('button[data-bs-toggle="tooltip"]')
  //   ).forEach((tooltipNode) => new Tooltip(tooltipNode));
  // },
};
</script>

<style></style>
